<template>
    <div class="form-group" :class="classObject">
        <label
                v-if="labelSide === 'left'"
                :class="['control-label', 'col-md-' + labelSize, disabled ? '' : 'pointer']"
                @click="onLabelClick"
        >
            {{ label }}
        </label>
        <div v-tooltip.left="tooltip" :class="'col-md-' + (12 - labelSize)">
            <label class="mt-checkbox mt-checkbox-outline" style="margin-top: 8px;">
                <input v-model="val" type="checkbox" :disabled="disabled"/>
                <span></span>
            </label>
            <span v-if="errorText" class="help-block">
                <p> {{errorText}} </p>
            </span>
        </div>
        <label
                v-if="labelSide === 'right'"
                :class="['control-label', 'pull-left', 'col-md-' + labelSize, disabled ? '' : 'pointer']"
                @click="onLabelClick"
        >
            {{ label }}
        </label>
    </div>
</template>

<script>
import VTooltip from 'v-tooltip'
import BaseInput from './baseInput.vue'
import Vue from 'vue'
Vue.use(VTooltip)
export default {
  extends: BaseInput,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Boolean, Number],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    checked: {
      type: [Number, Boolean],
      default: 0,
    },
    labelSize : {
      type: Number,
      default: 3,
    },
    labelSide: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right'].includes(value)
      }
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      val: null,
      errorText: false,
    }
  },
  watch : {
    val: function (value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.val = value
    },
    checked: function (value) {
      this.val = value
      this.$emit('input', value)
    }
  },
  mounted: function () {
    if (this.value) {
      this.val = this.value
    }

    this.$emit('input', this.value)
  },
  methods: {
    onLabelClick() {
      if (!this.disabled) {
        this.val = !this.val
      }
    }
  },
}
</script>

<style scoped>
.pull-left {
    text-align: left;
}

label {
    cursor: default;
}

label.pointer {
    cursor: pointer;
}
</style>
